import { render, staticRenderFns } from "./IconMinusCircle.vue?vue&type=template&id=17777ba0&"
import script from "./IconMinusCircle.vue?vue&type=script&lang=js&"
export * from "./IconMinusCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports